import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../config/endPoint";
import { httpGet } from "../../utils/api";
import DashboardLayout from "../layouts/dashboardLayout";
import DashboardCharts from "../dashboard/DashboardCharts";

const Dashboard = () => {
  const navigate = useNavigate();

  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [productData, setProductData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [usersData, setUsersData] = useState([]);      // ✅ NEW
  const [inquiryData, setInquiryData] = useState([]);  // ✅ NEW

  useEffect(() => {
    if (localStorage.getItem("jwt")) {
      getBrands();
      getCategory();
      getProducts();
      getContactData();
      getUsersData();   // ✅ NEW
      getInquiry();     // ✅ NEW
    } else {
      navigate("/login");
    }
  }, []);

  const getBrands = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/brand/list`);
      if (res?.data?.status) setBrandList(res.data.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getCategory = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/category/list`);
      if (res?.data?.status) setCategoryList(res.data.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getUsersData = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/users/list`);
      if (res?.data?.status) setUsersData(res.data.response);  // ✅ FIXED
    } catch (error) {
      console.error(error);
    }
  };

  const getInquiry = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/inquiry/list`);
      if (res?.data?.status) setInquiryData(res.data.response); // ✅ FIXED
    } catch (error) {
      console.error(error);
    }
  };

  const getProducts = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/product/list`);
      if (res?.data?.status) setProductData(res.data.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getContactData = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/contact_us/list`);
      if (res?.data?.status) setContactData(res.data.response);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <DashboardLayout>
      <div className="p-2 container-fluid" style={{ marginTop: "30px", maxWidth: "1250px" }}>
        <Row className="gy-4">
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Category</Card.Title>
                <Card.Text>{categoryList.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Brands</Card.Title>
                <Card.Text>{brandList.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Products</Card.Title>
                <Card.Text>{productData.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Users Contacts</Card.Title>
                <Card.Text>{contactData.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* ✅ NEW USERS CARD */}
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Logged-in Users</Card.Title>
                <Card.Text>{usersData.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* ✅ NEW INQUIRY CARD */}
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Total Product Inquiry Users</Card.Title>
                <Card.Text>{inquiryData.length}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* CHARTS */}
      <div className="container-fluid" style={{ marginTop: "30px", maxWidth: "1250px" }}>
        <div className="row g-4">
          {/* BAR */}
          <div className="col-lg-8">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-3">Overview</h5>
                <DashboardCharts
                  type="bar"
                  category={categoryList.length}
                  brands={brandList.length}
                  products={productData.length}
                  contacts={contactData.length}
                  users={usersData.length}       // ✅ NEW
                  inquiry={inquiryData.length}   // ✅ NEW
                />
              </div>
            </div>
          </div>

          {/* PIE */}
          <div className="col-lg-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-3">Distribution</h5>
                <DashboardCharts
                  type="pie"
                  category={categoryList.length}
                  brands={brandList.length}
                  products={productData.length}
                  contacts={contactData.length}
                  users={usersData.length}       // ✅ NEW
                  inquiry={inquiryData.length}   // ✅ NEW
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
